// extracted by mini-css-extract-plugin
export default {"root":"account-profile-photo-selector_root__Wekv0","selectPhoto":"account-profile-photo-selector_selectPhoto__I4fzP"};